module.exports = __webpack_public_path__ + "static/media/story-16.7893d35b.jpg";